import React, { useEffect } from 'react';
import { useHistory } from 'react-router';
import { useLocation, Link } from "react-router-dom";
import Spinner from 'react-bootstrap/Spinner';
import apiService from '../services/api.service';
import { appPath } from '../utils/appSlug';
import './login.css';

function useQuery() {
    const { search } = useLocation();
    return React.useMemo(() => new URLSearchParams(search), [search]);
}

const Verify = ({ appSlug }) => {
    const history = useHistory();
    const query = useQuery();
    const loginPath = appPath(appSlug, "login");
    const homePath = appPath(appSlug);

    useEffect(() => {
        const verifyUser = async () => {
            await apiService.verifyUser(query.get('id'), query.get('key'))
                .catch((error) => {
                    if (error.response?.data?.detail === "user already verified")
                        history.push(loginPath, { 'warnReason': "L'account è stato già validato in precedenza, puoi effettuare l'accesso con le tue credenziali" })
                    else {
                        history.push(loginPath, { 'failReason': "La validazione non è avvenuta con successo, se pensi che questo sia un errore contatta infoceformedsrl@gmail.com" })
                    }
                })
                .then((response) => {
                    if (response?.status === 200) {
                        history.push(loginPath, { 'successReason': "Validazione effettuata con successo, puoi effettuare l'accesso con le tue credenziali" })
                    }
                })
        }
        verifyUser()
    }, [history, loginPath, query]);

    return (
        <div className="login-page">
            <div className="login-card">
                <h1 className="login-title">Verifica account</h1>
                <p className="login-subtitle">
                    Stiamo confermando la tua registrazione. Verrai reindirizzato all&apos;area riservata tra pochi istanti.
                </p>
                <div className="login-verify-status" aria-live="polite">
                    <Spinner animation="border" role="status" className="login-verify-spinner">
                        <span className="visually-hidden">Caricamento...</span>
                    </Spinner>
                    <p>Validazione in corso...</p>
                </div>
                <p className="login-register-prompt">
                    <Link to={homePath}>Torna alla home</Link>
                </p>
            </div>
        </div>
    );
};

export default Verify;
